import IconWeb from "/src/assets/img/svg/web.svg";
import IconPhone from "/src/assets/img/svg/telephony.svg";
import IconRcs from "/src/assets/img/svg/rcs.svg";
import IconMessenger from "/src/assets/img/svg/mail.svg";
export default {
    web : IconWeb,
    telephony : IconPhone,
    messenger:IconMessenger,
    rcs : IconRcs
}